/* eslint-disable react/no-danger */
import { withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './HighlightText.styles';

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

const HighlightText = (props) => {
  const {
    string,
    toMatch
  } = props;

  const classes = useStyles(props);
  const regex = new RegExp(`${escapeRegExp(toMatch)}`, 'i'); // first case in-sensitive match
  const match = string.match(regex);

  const getHighlightedString = () => {
    const [prefix, ...suffix] = string.split(match[0]);

    return (
      <span className={classes.highlight}>
        {prefix}
        <span data-qa="option-mask">
          {match[0]}
        </span>
        {suffix.join(match[0])}
      </span>
    );
  };

  return match && match[0] !== ''
    ? getHighlightedString()
    : string;
};

HighlightText.propTypes = {
  /** String to add highlighs to */
  string: PropTypes.string.isRequired,

  /** Substring to highlight inside string  */
  toMatch: PropTypes.string.isRequired
};

export default withTheme(HighlightText);
